import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useAuth } from '@/src/app/hooks';
import { Menus } from '@/src/ui';
import { sanitizeGradeShortCode } from '@/src/utils';

// import AuthCallbackPage from '../pages/auth/authCallback/AuthCallbackPage';
import LoginRedirect from '@/src/pages/auth/login/LoginRedirect'; // ADD THIS

import DashboardPage from '@/src/pages/dashboard/DashboardPage';

import LessonsPage from '../pages/lessons/lessons/LessonsPage';
import AllLessonsPage from '../pages/lessons/allLessons/AllLessonsPage';

import AssessmentsPage from '../pages/resources/assessments/AssessmentsPage';
import BTBFPage from '../pages/resources/btbf/BTBFPage';
import ProfessionalLearningPage from '../pages/resources/professionalLearning/ProfessionalLearningPage';

import UserGuidesPage from '../pages/user/userGuides/UserGuidesPage';

// Routing & Auth
import NotAuthorizedPage from '@/src/app/components/NotAuthorizedPage';
// import NotFoundPage from '@/src/app/components/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Roles from './Roles';

const resourcesAllowedRoles = [
    Roles.SuperAdmin,
    Roles.DistrictAdmin,
    Roles.SchoolAdmin,
    Roles.Teacher,
];

function RoutesWrapper() {
    const { user, loading } = useAuth();
    useEffect(() => {
        const grade = sanitizeGradeShortCode(user?.gradeShortCode);
        document.documentElement.style.setProperty(
            '--scrollbar-color',
            `var(--pm-g${grade}-light)`
        );
    }, [user?.gradeShortCode]);

    return (
        <Routes>
            {/* <Route path="/authCallback" element={<AuthCallbackPage />} /> */}

            <Route element={<Menus />}>
                <Route element={<PublicRoute userExists={!!user} loading={loading} />}>
                    <Route path="login" element={<LoginRedirect />} />
                </Route>

                <Route
                    element={
                        <ProtectedRoute
                            allowedRoles={resourcesAllowedRoles}
                            user={user}
                            loading={loading}
                        />
                    }
                >
                    <Route path="dashboard" element={<DashboardPage />} />

                    <Route path="lessons" element={<LessonsPage />} />
                    <Route path="allLessons/:grade/:unit/:lesson" element={<AllLessonsPage />} />
                    <Route path="allLessons/:grade/:unit" element={<AllLessonsPage />} />
                    <Route path="allLessons/:grade?" element={<AllLessonsPage />} />

                    <Route path="resources/assessments/:grade?" element={<AssessmentsPage />} />
                    <Route path="resources/btbf" element={<BTBFPage />} />
                    <Route
                        path="resources/professionalLearning"
                        element={<ProfessionalLearningPage />}
                    />

                    <Route path="user/userGuides" element={<UserGuidesPage />} />
                </Route>

                <Route path="*" element={<Navigate to="/dashboard" replace />} />
                <Route path="not-authorized" element={<NotAuthorizedPage />} />
            </Route>
        </Routes>
    );
}

export default RoutesWrapper;
